import React, { Component } from 'react'
import './Footer.css'

import Res from '../values/Resources'

export default class Footer extends Component {
	render() {
		return (
			<div className='footer'>
				<h1>{Res.strings.footer_info}</h1>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/Footer.js